var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 2,
    fill: "#05CFDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55367 3.35348C7.74894 3.54874 7.74894 3.86532 7.55367 4.06058L4.90723 6.70703C4.71196 6.90229 4.39538 6.90229 4.20012 6.70703L2.55367 5.06058C2.35841 4.86532 2.35841 4.54874 2.55367 4.35348V4.35348C2.74894 4.15822 3.06552 4.15822 3.26078 4.35348L4.20012 5.29282C4.39538 5.48808 4.71196 5.48808 4.90723 5.29282L6.84657 3.35348C7.04183 3.15822 7.35841 3.15822 7.55367 3.35348V3.35348Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxActiveIcon);
export default __webpack_public_path__ + "static/media/CheckboxActiveIcon.b89f076b4f86beae847f8ff794eb1eaf.svg";
export { ForwardRef as ReactComponent };